export default {
  //不需要登录的页面,白名单
  notNeedLoginList: [
    '/pages/login/index',
    '/pages/home/index',
    '/pages/collect/index',
    '/pages/songs/index',
    '/pages/songs/play',
    '/pages/common/webview',
    '/pages/common/maintain',
    '/pages/common/protocol',
    '/pages/common/privacy',
    '/pages/login/bind',
    '/pages/common/download',
    '/pages/active/noThreshold',
    '/pages/active/noThresholdCollectDetail',
    '/pages/active/noThresholdSuccess',
    '/pages/selfSales/detail', // 自助售卖
    '/pages/selfSales/list',
    '/pages/home/musicMetaverse',
    '/pages/home/listenMusic',
    '/pages/home/newcomerRequired',
    '/pages/home/pengtouList',
    '/pages/home/searchSong',
    '/pages/home/superSearch',
    '/pages/home/superSearchList',
    '/pages/songs/songRecommend',
    '/pages/songs/name-list',
    '/pages/third/douyin/musiciansEnter',
    '/pages/market/detail', // 集市
    '/pages/market/numberDetail', // 集市详情
    '/pages/home/pengTouDetail', // 捧投
    '/pages/home/goodsDetails', // 首发
    '/pages/user/musicianHome/musicHall',
  ],
  tabbarList: [
    // "/",
    '/pages/home/index',
    '/pages/market/index',
    '/pages/songs/index',
    '/pages/collect/index',
    '/pages/user/index'
  ],
  //登录页
  loginPage: '/pages/login/index',
  // 绑定手机号页面
  loginBindPage: '/pages/login/bind', // 跳转这个页面需要token
}
